
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/songs/[id]",
      function () {
        return require("private-next-pages/store/songs/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/songs/[id]"])
      });
    }
  